export const circlesArr = [
  { color: 'yellow', id: 'ut_Nuav0xEMzDjjMyd6q6', index: 0 },
  { color: 'green', id: 'QBJTnI2RRy4ND1UHyGGhq', index: 1 },
  { color: 'blue', id: '24lRTDJmw41nG26JB9AvU', index: 2 },
  { color: 'red', id: 'mhtKviB8XFIQw8zES0LVi', index: 3 },
  { color: 'blue', id: '-JSsfwHgoYnQhdwC5o7Vw', index: 4 },
  { color: 'red', id: 'zIctPDYyA52QhH56q0OKj', index: 5 },
  { color: 'blue', id: 'TO6RCf8Exczd59QxS9xW_', index: 6 },
  { color: 'red', id: 'CJ60REe4pfb28zPVPTzdY', index: 7 },
  { color: 'blue', id: 'DY1wee4Xl8kY5hkS34LEE', index: 8 },
  { color: 'green', id: '_uPV2YQeo-sUNtAtJFyo-', index: 9 },
  { color: 'blue', id: 'Uf1sMzpXPg4NF5pZ1aaUI', index: 10 },
  { color: 'green', id: 't3Wo7drja-fjqz8FlxRlA', index: 11 },
  { color: 'blue', id: 'UVCdlOqb_oQ9ScALzLs4p', index: 12 },
  { color: 'red', id: 'FqzwwLNyncBW7PUTy3j5V', index: 13 },
  { color: 'blue', id: 'sOHzROETYxkEs69UFmzoc', index: 14 },
  { color: 'red', id: 'EMpT9OO16rd2BDSvrVGia', index: 15 },
  { color: 'blue', id: 'ttmee_1JHlzFfo3J-9n9C', index: 16 },
  { color: 'red', id: 'W9NvwQysOWdgOSwTAOGGE', index: 17 },
  { color: 'blue', id: 'ThogbRIzmUrOZsgzJxLpy', index: 18 },
  { color: 'green', id: 'jK25Y7_E97VYJdTLNgNlt', index: 19 },
  { color: 'blue', id: '0fj01wu9J08bVeTysvsO4', index: 20 },
  { color: 'green', id: 'HIi1ygZtkS_q7IbK4hKmk', index: 21 },
  { color: 'blue', id: '9-ZItWjsIm7sdiaNlDSxr', index: 22 },
  { color: 'red', id: 'orDhXbGz4NoEqgwDdGoAM', index: 23 },
  { color: 'blue', id: 'YZqMUMGIVfe1wDEcB-ufB', index: 24 },
  { color: 'red', id: 'gxt4OG-yJ8vOCzm7FB8fK', index: 25 },
  { color: 'blue', id: '1Odl8tIZMvMSlghGn1RfD', index: 26 },
  { color: 'red', id: 'J7nPBR13_eqnLBRWK_Dgq', index: 27 },
  { color: 'blue', id: 'WXwR_nY8UneleBu2sb5VA', index: 28 },
  { color: 'red', id: 'pfO_is_dfGDYk3hdS6LwX', index: 29 },
  { color: 'blue', id: 'jUfhogXCenSo8093-fdD9', index: 30 },
  { color: 'red', id: 'N-Q2zCawQJK43T-bJIZOj', index: 31 },
  { color: 'blue', id: '9C0fUT2-eQicGuTKv9R0P', index: 32 },
  { color: 'green', id: 'K-dRqQ8BC20akA73Sl4JT', index: 33 },
  { color: 'blue', id: 'vO8c1VrrSu-ieOK9c8Ob8', index: 34 },
  { color: 'green', id: 'MQu3ZP8vK9mVj2wQ3sUYO', index: 35 },
  { color: 'blue', id: 'beJ_4Tj4fni9Ip48m_sto', index: 36 },
  { color: 'red', id: '4vF0TbO2UJaWkluk0A33Y', index: 37 },
  { color: 'blue', id: 'N8w3jU29nEo1xPO7-uOuG', index: 38 },
  { color: 'red', id: 'G3YzCcUXHRjxNe7CgSrt_', index: 39 },
  { color: 'blue', id: 'OuWRQVepht-OhsSe92Ls1', index: 40 },
  { color: 'red', id: 'x5ZGa7-J1rcO41waeAOyb', index: 41 },
  { color: 'blue', id: 'Bj-emVY7-GCaETmptRKMO', index: 42 },
  { color: 'green', id: '-aw3uYdIL8BgoVAt9d1Id', index: 43 },
  { color: 'blue', id: 'T24b0tSIHZNqmC6xHguHC', index: 44 },
  { color: 'green', id: '11hDOHo7FkhKyzL6P9Qb7', index: 45 },
  { color: 'blue', id: 'HsMNNje0PWZwaBMTMFiyR', index: 46 },
  { color: 'red', id: 'yVwk9qKo0-cNxMrPaytcw', index: 47 },
  { color: 'blue', id: 'iQfEoyhl6cht2IEBzrGSy', index: 48 },
  { color: 'red', id: 'VduqcLTPbJ3vWek51xtWM', index: 49 },
  { color: 'blue', id: 'YlcnLpc8o9IjcBaosl55Z', index: 50 },
  { color: 'red', id: 'kAGZbyA-TrGepBlNVF-UB', index: 51 },
  { color: 'blue', id: 'X8_4RxgoVJhOkDqXgEF0b', index: 52 },
  { color: 'green', id: '2hyTjgmkolrmHIT12MroP', index: 53 },
];
